enum ApiHeader {
  ApiVersion = 'x-md-api-version',
  BiteServiceName = 'x-bite-service-name',
  CustomerToken = 'x-customer-token',
  CustomerAppScope = 'x-customer-app-scope',
  EloViewCiToken = 'x-elo-view-ci-token',
  FlashSessionId = 'x-flash-session-id',
  GarconBuildName = 'x-garcon-build-name',
  GcnBuildName = 'x-gcn-build-name',
  VitrineBuildName = 'x-vitrine-build-name',
  KioskBuildName = 'x-kiosk-build-name',
  KioskId = 'x-bite-kiosk-id',
  KioskIdDeprecated = 'x-kiosk-id',
  KioskOs = 'x-kiosk-os',
  LocationId = 'x-bite-location-id',
  OrderChannel = 'x-bite-order-channel',
  OrgId = 'x-bite-org-id',
  PublicKey = 'x-bite-public-key',
  RefundToken = 'x-bite-refund-token',
  ReleaseBuildsCiToken = 'x-release-builds-ci-token',
  SiteId = 'x-bite-site-id',
}

export { ApiHeader };
